import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import { toast, formatMutationError } from './lib/toast'
import { ApiError, setWriteDenialHandler } from './api/client'

// FC-Finding #3 (Integration): auch Writes, die NICHT ueber TanStack-Mutationen
// laufen (z.B. Sync.tsx api.put/api.post), toasten 403/423 global.
setWriteDenialHandler((error) => {
  toast.error(formatMutationError(error))
})

const queryClient = new QueryClient({
  // Globale Sichtbarkeit: JEDE fehlgeschlagene Mutation der App zeigt einen Toast
  // (423 Demo-Modus / 403 Berechtigung / sonst Fehlertext) — verpufft nie mehr still.
  mutationCache: new MutationCache({
    onError: (error) => {
      // Write-Denials (403/423) hat der API-Client bereits getoastet — nicht doppeln.
      if (error instanceof ApiError && error.toasted) return
      toast.error(formatMutationError(error))
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
